const isLocationOnMemberships = (eventType) => {
  if (eventType.pooling_type === 'round_robin') { return true }
  if (eventType.ignore_location_configurations) { return true }

  return false
}

export const useEventTypeLocation = (eventType = {}) => {
  // One-off meetings
  if (eventType?.locationType) return eventType.locationType

  if (eventType.location_type && eventType.location_type !== null) {
    return eventType.location_type
  }

  if (isLocationOnMemberships(eventType)) { return null }

  return eventType.location_configurations?.[0]?.kind || null
}
